import * as React from 'react'
import moment from 'moment'
import { Box } from '@material-ui/core'
import SWeventCard from './ScarletWellEventCard'
import IconPicker from '../../../apps/AppComponents/IconPicker/IconPicker'
import { eventCardStyles } from './scarletWellEventCardStyles'

const SWeventList = ({ events, handleClick }) => {
  const classes = eventCardStyles()
  const filteredEvents = [...events]
    .sort((a, b) => moment(a.utc_start_date) - moment(b.utc_start_date))
    // sort chronologically
    .filter((event) => {
      if (!moment(event.utc_start_date).isBefore(moment())) {
        // keep events in the future
        return true
      }
      // discard events in the past
      return false
    })
  return (
    <Box className={classes.eventsTabContent}>
      {filteredEvents.length === 0 ? (
        <Box className={classes.emptyEventListWrapper}>
          <IconPicker iconName="far fa-bug" color="gray" size="2x" />
          No Events found
        </Box>
      ) : (
        filteredEvents?.map((event) => (
          <Box key={event.title}>
            <SWeventCard
              classes={classes}
              data={event}
              handleClick={handleClick}
            />
          </Box>
        ))
      )}
    </Box>
  )
}

export default SWeventList
